enum PlanStatusType {
  PRIVATE = "PRIVATE",
  PUBLISH = "PUBLISH",
}

export default PlanStatusType;
